<div [ngClass]="{'header-bar-safe-area': true, 'transparent': webNavService.footerMode === FOOTER_MODE.CARD_FULLSCREEN}" class="" ></div>


<div class="navbar-safe-area"></div>
<div *ngIf="webNavService.footerMode !== FOOTER_MODE.DEFAULT"  class="navbar-footer-wrapper" [ngClass]="{'transparent-nav' : webNavService.footerMode === FOOTER_MODE.CARD_FULLSCREEN }" fxLayout="column"  fxLayoutAlign="space-between start" >

  <div class="webfoot-row" [appResponsiveClass]="'rowsize'"   [class.useAllSpaceForSmallScreen]="getIsThisWebNavShouldBeFullScreenOnSmallDevices()"  [class]="webNavService.footerMode" [class.has-refund-note]="webNavService.footerMode === FOOTER_MODE.LIBRARY && webNavService.shouldShowClassicLanding()" [class.open-app-only]="shouldShowOpenAppCta()">

    <!-- <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.WEB_HOME">
      <div class="foot-left"></div>
      <div class="foot-main transparent">
        <button *ngIf="isUserAuthenticated" class="add-web-btn" (click)="goToLibrary()">
          <span (click)="goToLibrary()">Library</span>
        </button>
        <button *ngIf="!isUserAuthenticated" class="sign-in-with-apple" (click)="onSignInWithAppleClicked()">
          <svg (click)="onSignInWithAppleClicked()" class="apple-logo" width="22" height="22" viewBox="0 0 22 22"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.0294 1.91442C13.5188 0.00928785 15.5895 0 15.5895 0C15.5895 0 15.8975 1.79114 14.4178 3.51659C12.8379 5.35898 11.0421 5.0575 11.0421 5.0575C11.0421 5.0575 10.7049 3.60853 12.0294 1.91442ZM11.2316 6.31219C11.9978 6.31219 13.4199 5.29003 15.2709 5.29003C18.4571 5.29003 19.7106 7.4903 19.7106 7.4903C19.7106 7.4903 17.2591 8.70672 17.2591 11.6583C17.2591 14.9879 20.313 16.1354 20.313 16.1354C20.313 16.1354 18.1782 21.9668 15.2946 21.9668C13.9702 21.9668 12.9406 21.1007 11.5451 21.1007C10.123 21.1007 8.71182 21.9991 7.79269 21.9991C5.15956 21.9992 1.83301 16.4675 1.83301 12.021C1.83301 7.64625 4.64872 5.35132 7.28974 5.35132C9.00665 5.35132 10.339 6.31219 11.2316 6.31219Z"
              fill="black" />
          </svg>
          <span>Continue with Apple</span>
        </button>
      </div>
      <div class="foot-right"></div>
    </ng-container> -->

    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.COLLECTION_DETAILS">
      <div class="foot-left-part"></div>
    <div class="foot-right-part">
      <div class="foot-main" >
        <button class="back-web-btn" (click)="onLessButtonClicked($event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="onLessButtonClicked( $event)"  class="web-btn-text">Back</span>
        </button>

        <button class="buy-web-btn main-web-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.BUY, $event)"><span>Not for sale</span></button>

        <button class="share-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.SHARE, $event)" >
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" viewBox="0 0 19 24" fill="none">
            <path d="M3.33637 24H15.6638C16.7401 24 17.5519 23.7265 18.0992 23.1795C18.6464 22.6324 18.9201 21.8256 18.9201 20.7589V9.95557C18.9201 8.8889 18.6464 8.08435 18.0992 7.54189C17.5519 6.99946 16.7401 6.72824 15.6638 6.72824H12.6401V8.24618H15.6364C16.1928 8.24618 16.6261 8.39432 16.9362 8.69062C17.2463 8.98691 17.4014 9.43135 17.4014 10.0239V20.6906C17.4014 21.2832 17.2463 21.7276 16.9362 22.0239C16.6261 22.3202 16.1928 22.4683 15.6364 22.4683H3.36374C2.79821 22.4683 2.36267 22.3202 2.05712 22.0239C1.75154 21.7276 1.59876 21.2832 1.59876 20.6906V10.0239C1.59876 9.43135 1.75154 8.98691 2.05712 8.69062C2.36267 8.39432 2.79821 8.24618 3.36374 8.24618H6.36006V6.72824H3.33637C2.26006 6.72824 1.44827 6.99718 0.90099 7.53506C0.353716 8.07296 0.0800781 8.87979 0.0800781 9.95557V20.7589C0.0800781 21.8347 0.353716 22.6438 0.90099 23.1863C1.44827 23.7287 2.26006 24 3.33637 24Z" fill="white"/>
            <path d="M9.49305 15.6717C9.70283 15.6717 9.88297 15.6011 10.0335 15.4598C10.184 15.3185 10.2592 15.143 10.2592 14.9333V3.66496L10.1908 2.07863L11.0254 2.96751L12.763 4.77262C12.8907 4.92761 13.0595 5.00511 13.2693 5.00511C13.4699 5.00511 13.6364 4.94129 13.7687 4.81365C13.9009 4.68602 13.967 4.52647 13.967 4.33502C13.967 4.1527 13.8895 3.98859 13.7345 3.84272L10.0403 0.246151C9.9491 0.154979 9.86017 0.0911611 9.77353 0.0546963C9.68687 0.0182316 9.59338 0 9.49305 0C9.40183 0 9.31289 0.0182316 9.22623 0.0546963C9.13959 0.0911611 9.0461 0.154979 8.94575 0.246151L5.25164 3.84272C5.09658 3.98859 5.01904 4.1527 5.01904 4.33502C5.01904 4.52647 5.08289 4.68602 5.21059 4.81365C5.33829 4.94129 5.50703 5.00511 5.71681 5.00511C5.92661 5.00511 6.09992 4.92761 6.23674 4.77262L7.96065 2.96751L8.80895 2.07863L8.74052 3.66496V14.9333C8.74052 15.143 8.81578 15.3185 8.96629 15.4598C9.11679 15.6011 9.29238 15.6717 9.49305 15.6717Z" fill="white"/>
          </svg>
          <span  class="web-btn-text" >Share</span>
        </button>

        <button class="like-web-btn" [ngClass]="{'active' : isSaved(cardService.getCurrentCard()) === true, 'not-active': isSaved(cardService.getCurrentCard()) ===  false}" (click)="onCollectionLikeClicked($event)" >
          <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5 21.75C17.1609 21.75 21.75 17.1609 21.75 11.5C21.75 5.83908 17.1609 1.25 11.5 1.25C5.83908 1.25 1.25 5.83908 1.25 11.5C1.25 17.1609 5.83908 21.75 11.5 21.75ZM22.25 11.5C22.25 17.4371 17.4371 22.25 11.5 22.25C5.56294 22.25 0.75 17.4371 0.75 11.5C0.75 5.56294 5.56294 0.75 11.5 0.75C17.4371 0.75 22.25 5.56294 22.25 11.5Z" fill="white" stroke="white" stroke-width="0.8"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4785 6.01627C12.0308 6.01627 12.4785 6.46398 12.4785 7.01627L12.4785 15.9837C12.4785 16.5359 12.0308 16.9837 11.4785 16.9837C10.9262 16.9837 10.4785 16.5359 10.4785 15.9837L10.4785 7.01627C10.4785 6.46398 10.9262 6.01627 11.4785 6.01627Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99445 11.4816C5.99536 10.9293 6.44381 10.4823 6.99609 10.4832L15.9635 10.498C16.5158 10.4989 16.9627 10.9473 16.9618 11.4996C16.9609 12.0519 16.5125 12.4989 15.9602 12.498L6.9928 12.4832C6.44052 12.4823 5.99354 12.0338 5.99445 11.4816Z" fill="white"/>
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM11.8032 15.7866C11.5903 16.0964 11.3195 16.2513 10.9905 16.2513C10.8164 16.2513 10.6616 16.2174 10.5262 16.1496C10.3907 16.0819 10.2601 15.9609 10.1344 15.7866L7.23216 12.2582C7.07739 12.0549 7 11.8468 7 11.6338C7 11.4112 7.07497 11.2224 7.22491 11.0676C7.37487 10.9127 7.5611 10.8352 7.78359 10.8352C7.91903 10.8352 8.04479 10.8643 8.16087 10.9223C8.27697 10.9804 8.39789 11.0869 8.52364 11.2418L10.947 14.3056L15.8953 6.45013C16.0791 6.15004 16.3064 6 16.5773 6C16.7901 6 16.9812 6.06776 17.1505 6.20329C17.3198 6.33881 17.4044 6.51789 17.4044 6.74052C17.4044 6.85669 17.3778 6.96802 17.3246 7.0745C17.2714 7.18098 17.2158 7.28262 17.1577 7.37943L11.8032 15.7866Z" fill="white"/>
          </svg>
          <span *ngIf="!isSaved(cardService.getCurrentCard())" class="web-btn-text" >Save</span>
          <span *ngIf="isSaved(cardService.getCurrentCard())"  class="web-btn-text" >Added</span>
        </button>

        <!-- <button class="account-web-btn" [matMenuTriggerFor]="collectionDetailsMenu">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="10.5" r="2" fill="white" />
            <circle cx="11" cy="10.5" r="2" fill="white" />
            <circle cx="19" cy="10.5" r="2" fill="white" />
          </svg>
          <span class="web-btn-text">More</span>
        </button>
        <mat-menu #collectionDetailsMenu="matMenu">
          <app-webpanel [webpanelActionItems]="getProperCollectionDetailsWebPanelItems()"
            (webpanelActionClickEvent)="handleWebpanelActionClick($event)"></app-webpanel>
        </mat-menu> -->
      </div>
      </div>

    </ng-container>

    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.STORE">

      <div class="foot-left-part  xxs-modification">
        <div class="foot-left-part-content-nav shift-with-cards">
          <h2 class="web-title">Home</h2>
        </div>
      </div>
      <div class="foot-right-part xs-columnreverse xs-flex100 gt-xs-columnreverse">
        <div class="foot-main xs-alignSelfCenter gt-xs-alignSelfBase">
          <button class="home-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
              <path d="M16.9167 4.2H5.08333M15.3333 1.5H6.66667M18 22.5H4C2.61929 22.5 1.5 21.3807 1.5 20L1.5 9.62673C1.5 8.24602 2.61929 7.12673 4 7.12673H18C19.3807 7.12673 20.5 8.24602 20.5 9.62673V20C20.5 21.3807 19.3807 22.5 18 22.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)">Library</span>
          </button>

          <button class="publish-web-btn main-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.PUBLISH, $event)">
            <span>Publish</span>
          </button>

          <!-- <button class="search-web-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"
              (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
              <path
                d="M0.75 8.9375C0.75 13.4593 4.41567 17.125 8.9375 17.125C13.4593 17.125 17.125 13.4593 17.125 8.9375C17.125 4.41567 13.4593 0.75 8.9375 0.75C4.41567 0.75 0.75 4.41567 0.75 8.9375Z"
                stroke="white" stroke-width="1.5" stroke-linecap="round" />
              <path d="M20.9824 20.9687L15.3558 15.355" stroke="white" stroke-width="2" stroke-linecap="round" />
              <circle xmlns="http://www.w3.org/2000/svg" cx="9" cy="9" r="5" />
            </svg>
            <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">Search</span>
          </button>

          <div class="web-nav-divider"></div> -->

          <button class="account-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.ACCOUNT, $event)">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="3" cy="10.5" r="2" fill="white" />
              <circle cx="11" cy="10.5" r="2" fill="white" />
              <circle cx="19" cy="10.5" r="2" fill="white" />
            </svg>
            <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.ACCOUNT, $event)">Account</span>
          </button>
        </div>
      </div>
    </ng-container>


    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.ADMIN_REVIEW">
      <div class="foot-left-part xs-flex0"></div>
      <div class="foot-right-part xs-columnreverse xs-flex100 gt-xs-columnreverse">
        <div class="foot-main xs-alignSelfCenter gt-xs-alignSelfBase">
        <button class="back-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)"  class="web-btn-text">Back</span>
        </button>
          <button class="publish-web-btn main-web-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.PUBLISH, $event)">
            <span>Publish</span>
          </button>

          <!-- <button class="search-web-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"
              (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
              <path
                d="M0.75 8.9375C0.75 13.4593 4.41567 17.125 8.9375 17.125C13.4593 17.125 17.125 13.4593 17.125 8.9375C17.125 4.41567 13.4593 0.75 8.9375 0.75C4.41567 0.75 0.75 4.41567 0.75 8.9375Z"
                stroke="white" stroke-width="1.5" stroke-linecap="round" />
              <path d="M20.9824 20.9687L15.3558 15.355" stroke="white" stroke-width="2" stroke-linecap="round" />
              <circle xmlns="http://www.w3.org/2000/svg" cx="9" cy="9" r="5" />
            </svg>
            <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">Search</span>
          </button>

          <div class="web-nav-divider"></div> -->

          <button class="account-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.ACCOUNT, $event)">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="3" cy="10.5" r="2" fill="white" />
              <circle cx="11" cy="10.5" r="2" fill="white" />
              <circle cx="19" cy="10.5" r="2" fill="white" />
            </svg>
            <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.ACCOUNT, $event)">Account</span>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.LIBRARY">
      <ng-container *ngIf="shouldShowOpenAppCta(); else libraryDefaultNav">
        <div class="foot-right-part xxs-modification open-app-only">
          <div class="foot-main open-app-cta">
            <button class="add-web-btn main-web-btn" (click)="onOpenAppClicked($event)">
              <span>Open App</span>
            </button>
          </div>
        </div>
      </ng-container>

  <ng-template #libraryDefaultNav>
      <div class="foot-left-part xxs-modification">
        <div class="foot-left-part-content-nav shift-with-cards">
          <h2 class="web-title" *ngIf="!webNavService.shouldShowClassicLanding()">Your Library</h2>
        </div>
      </div>
      <div class="foot-right-part xxs-modification">
      <div class="foot-main" >
        <button class="home-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.HOME, $event)">
          <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 0.75L0.75 8.22675V21.25H7.0278V14.531C7.0278 14.0567 7.4083 13.6722 7.8778 13.6722H12.1222C12.5917 13.6722 12.9722 14.0567 12.9722 14.531V21.25H19.25V8.22674L10 0.75Z"
              fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.HOME, $event)">Home</span>
        </button>
        <button *ngIf="!webNavService.isUserAuthenticated" class="add-web-btn main-web-btn" (click)="handleUnauthorizedUserActionDetected()">
          <span *ngIf="webNavService.shouldShowClassicLanding(); else addLabel">
            {{ webNavService.unauthLibraryMainCtaLabel }}
          </span>
          <ng-template #addLabel>
            <span>Add</span>
          </ng-template>
        </button>
          <button *ngIf="webNavService.isUserAuthenticated" class="add-web-btn main-web-btn" [matMenuTriggerFor]="addMenu" #menuTrigger="matMenuTrigger">
            <span>Add</span>
          </button>
        <mat-menu #addMenu="matMenu">
          <!-- <app-fullsize-dragdrop [modeLocal]="true"></app-fullsize-dragdrop> -->
          <app-webpanel [webpanelActionItems]="webNavService.addWebPanelItems"
            (webpanelActionClickEvent)="handleWebpanelActionClick($event)"></app-webpanel>
        </mat-menu>

        <!-- <button *ngIf="!webNavService.shouldHideLibrarySearchAndDivider()" class="search-web-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"
            (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
            <path
              d="M0.75 8.9375C0.75 13.4593 4.41567 17.125 8.9375 17.125C13.4593 17.125 17.125 13.4593 17.125 8.9375C17.125 4.41567 13.4593 0.75 8.9375 0.75C4.41567 0.75 0.75 4.41567 0.75 8.9375Z"
              stroke="white" stroke-width="1.5" stroke-linecap="round" />
            <path d="M20.9824 20.9687L15.3558 15.355" stroke="white" stroke-width="2" stroke-linecap="round" />
            <circle xmlns="http://www.w3.org/2000/svg" cx="9" cy="9" r="5" />
          </svg>
          <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">Search</span>
        </button>

        <div *ngIf="!webNavService.shouldHideLibrarySearchAndDivider()" class="web-nav-divider"></div> -->

        <!-- <button class="account-web-btn" [matMenuTriggerFor]="accountMenu"> -->
          <button class="account-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.ACCOUNT, $event)">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="3" cy="10.5" r="2" fill="white" />
              <circle cx="11" cy="10.5" r="2" fill="white" />
              <circle cx="19" cy="10.5" r="2" fill="white" />
            </svg>
            <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.ACCOUNT, $event)">Account</span>
          </button>
        </div>
      </div>
  </ng-template>
    </ng-container>

    <!-- <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.LIBRARY_PUBLISH_REJECTED_REVIEW">

      <div class="foot-left-part">
        <div class="foot-left-part-content-nav">
          <h2 class="web-title">Published By You</h2>
        </div>
      </div>
      <div class="foot-right-part">
      <div class="foot-main" >

        <button class="back-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)"  class="web-btn-text">Back</span>
        </button>

        <button class="publish-web-btn main-web-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.NOT_IMPL, $event)" >
          <span>Publish</span>
        </button>

        <button class="search-web-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"
            (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
            <path
              d="M0.75 8.9375C0.75 13.4593 4.41567 17.125 8.9375 17.125C13.4593 17.125 17.125 13.4593 17.125 8.9375C17.125 4.41567 13.4593 0.75 8.9375 0.75C4.41567 0.75 0.75 4.41567 0.75 8.9375Z"
              stroke="white" stroke-width="1.5" stroke-linecap="round" />
            <path d="M20.9824 20.9687L15.3558 15.355" stroke="white" stroke-width="2" stroke-linecap="round" />
            <circle xmlns="http://www.w3.org/2000/svg" cx="9" cy="9" r="5" />
          </svg>
          <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">Search</span>
        </button>
      </div>
      <div class="foot-last">
        <app-see-all-switch [selectedSwitchBtn]="webNavService.currentWebSwitchPanelMode" (switchBtnClicked)="webNavService.onWebNavSwitchPanelClick($event)" ></app-see-all-switch>
      </div>
      </div>
    </ng-container> -->

    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.PORTFOLIO">

      <div class="foot-left-part xs-flex0"></div>
      <div class="foot-right-part xs-columnreverse xs-flex100 gt-xs-columnreverse">
        <div class="foot-main xs-alignSelfCenter gt-xs-alignSelfBase" >

        <button class="back-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)"  class="web-btn-text">Back</span>
        </button>

        <button class="add-web-btn main-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.UPLOAD, $event)">
          <span>Upload</span>
        </button>


        <!-- <button class="search-web-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"
            (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
            <path
              d="M0.75 8.9375C0.75 13.4593 4.41567 17.125 8.9375 17.125C13.4593 17.125 17.125 13.4593 17.125 8.9375C17.125 4.41567 13.4593 0.75 8.9375 0.75C4.41567 0.75 0.75 4.41567 0.75 8.9375Z"
              stroke="white" stroke-width="1.5" stroke-linecap="round" />
            <path d="M20.9824 20.9687L15.3558 15.355" stroke="white" stroke-width="2" stroke-linecap="round" />
            <circle xmlns="http://www.w3.org/2000/svg" cx="9" cy="9" r="5" />
          </svg>
          <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">Search</span>
        </button>

        <div class="web-nav-divider"></div>

        <button class="account-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.ACCOUNT, $event)">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="10.5" r="2" fill="white" />
            <circle cx="11" cy="10.5" r="2" fill="white" />
            <circle cx="19" cy="10.5" r="2" fill="white" />
          </svg>
          <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.ACCOUNT, $event)">Account</span>
        </button> -->
        <!-- <mat-menu #accountMenu="matMenu">
          <app-webpanel [webpanelActionItems]="webNavService.libraryAccountWebPanelItems"
            (webpanelActionClickEvent)="handleWebpanelActionClick($event)"></app-webpanel>
        </mat-menu> -->

      </div>
      <div class="foot-last xs-alignSelfCenter gt-xs-alignSelfBase xs-removeMargin gt-xs-removeMargin" *ngIf="!webNavService.hideLibrarySectionSwitch">
        <app-library-section-switch #switchPanelRef [selectedSwitchBtn]="webNavService.currentWebSwitchPanelMode"  (switchBtnClicked)="webNavService.onWebNavSwitchPanelClick($event)"></app-library-section-switch>
      </div>
      </div>

    </ng-container>

    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.USER_PUBLISH_REJECTED_REVIEW">


      <div class="foot-left-part   xxs-modification"></div>
      <div class="foot-right-part xs-columnreverse xs-flex100 gt-xs-columnreverse">
        <div class="foot-main xs-alignSelfCenter gt-xs-alignSelfBase" >

        <button class="back-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)"  class="web-btn-text">Back</span>
        </button>

        <button class="add-web-btn main-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.PUBLISH, $event)">
          <span>Publish</span>
        </button>

      </div>
      </div>

    </ng-container>

    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.EDIT_COLLECTION">

      <div class="foot-left-part xs-flex0"></div>
      <div class="foot-right-part xs-columnreverse xs-flex100 gt-xs-columnreverse ">
      <div class="foot-main xs-alignSelfCenter gt-xs-alignSelfBase gt-xs-mr20" >

        <button class="back-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)"  class="web-btn-text">Back</span>
        </button>
        <button class="add-web-btn main-web-btn" [disabled]="navForSavedCollection" [matMenuTriggerFor]="addMenu" #menuTrigger (click)="checkIfUserAbleToAddFromLibraryAndModifyNavpanelItem()">
          <span>Add</span>
        </button>
        <mat-menu #addMenu="matMenu">
          <app-webpanel [webpanelActionItems]="webNavService.editCollectionAddWebPanelItems"
            (webpanelActionClickEvent)="handleWebpanelActionClick($event)"></app-webpanel>
        </mat-menu>

        <button class="share-web-btn"  (click)="navbarBtnClick(NAVBAR_BTN.SHARE, $event)" >
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" viewBox="0 0 19 24" fill="none" >
            <path d="M3.33637 24H15.6638C16.7401 24 17.5519 23.7265 18.0992 23.1795C18.6464 22.6324 18.9201 21.8256 18.9201 20.7589V9.95557C18.9201 8.8889 18.6464 8.08435 18.0992 7.54189C17.5519 6.99946 16.7401 6.72824 15.6638 6.72824H12.6401V8.24618H15.6364C16.1928 8.24618 16.6261 8.39432 16.9362 8.69062C17.2463 8.98691 17.4014 9.43135 17.4014 10.0239V20.6906C17.4014 21.2832 17.2463 21.7276 16.9362 22.0239C16.6261 22.3202 16.1928 22.4683 15.6364 22.4683H3.36374C2.79821 22.4683 2.36267 22.3202 2.05712 22.0239C1.75154 21.7276 1.59876 21.2832 1.59876 20.6906V10.0239C1.59876 9.43135 1.75154 8.98691 2.05712 8.69062C2.36267 8.39432 2.79821 8.24618 3.36374 8.24618H6.36006V6.72824H3.33637C2.26006 6.72824 1.44827 6.99718 0.90099 7.53506C0.353716 8.07296 0.0800781 8.87979 0.0800781 9.95557V20.7589C0.0800781 21.8347 0.353716 22.6438 0.90099 23.1863C1.44827 23.7287 2.26006 24 3.33637 24Z" fill="white"/>
            <path d="M9.49305 15.6717C9.70283 15.6717 9.88297 15.6011 10.0335 15.4598C10.184 15.3185 10.2592 15.143 10.2592 14.9333V3.66496L10.1908 2.07863L11.0254 2.96751L12.763 4.77262C12.8907 4.92761 13.0595 5.00511 13.2693 5.00511C13.4699 5.00511 13.6364 4.94129 13.7687 4.81365C13.9009 4.68602 13.967 4.52647 13.967 4.33502C13.967 4.1527 13.8895 3.98859 13.7345 3.84272L10.0403 0.246151C9.9491 0.154979 9.86017 0.0911611 9.77353 0.0546963C9.68687 0.0182316 9.59338 0 9.49305 0C9.40183 0 9.31289 0.0182316 9.22623 0.0546963C9.13959 0.0911611 9.0461 0.154979 8.94575 0.246151L5.25164 3.84272C5.09658 3.98859 5.01904 4.1527 5.01904 4.33502C5.01904 4.52647 5.08289 4.68602 5.21059 4.81365C5.33829 4.94129 5.50703 5.00511 5.71681 5.00511C5.92661 5.00511 6.09992 4.92761 6.23674 4.77262L7.96065 2.96751L8.80895 2.07863L8.74052 3.66496V14.9333C8.74052 15.143 8.81578 15.3185 8.96629 15.4598C9.11679 15.6011 9.29238 15.6717 9.49305 15.6717Z" fill="white"/>
          </svg>
          <span  class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.SHARE, $event)">Share</span>
        </button>

        <button *ngIf="navForSavedCollection" class="like-web-btn"
          [ngClass]="{'active' : isSavedCollectionCheck(sourceCollection) === true, 'not-active': isSavedCollectionCheck(sourceCollection) ===  false}"
          (click)="onCollectionLikeClicked($event)" >
          <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5 21.75C17.1609 21.75 21.75 17.1609 21.75 11.5C21.75 5.83908 17.1609 1.25 11.5 1.25C5.83908 1.25 1.25 5.83908 1.25 11.5C1.25 17.1609 5.83908 21.75 11.5 21.75ZM22.25 11.5C22.25 17.4371 17.4371 22.25 11.5 22.25C5.56294 22.25 0.75 17.4371 0.75 11.5C0.75 5.56294 5.56294 0.75 11.5 0.75C17.4371 0.75 22.25 5.56294 22.25 11.5Z" fill="white" stroke="white" stroke-width="0.8"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4785 6.01627C12.0308 6.01627 12.4785 6.46398 12.4785 7.01627L12.4785 15.9837C12.4785 16.5359 12.0308 16.9837 11.4785 16.9837C10.9262 16.9837 10.4785 16.5359 10.4785 15.9837L10.4785 7.01627C10.4785 6.46398 10.9262 6.01627 11.4785 6.01627Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99445 11.4816C5.99536 10.9293 6.44381 10.4823 6.99609 10.4832L15.9635 10.498C16.5158 10.4989 16.9627 10.9473 16.9618 11.4996C16.9609 12.0519 16.5125 12.4989 15.9602 12.498L6.9928 12.4832C6.44052 12.4823 5.99354 12.0338 5.99445 11.4816Z" fill="white"/>
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM11.8032 15.7866C11.5903 16.0964 11.3195 16.2513 10.9905 16.2513C10.8164 16.2513 10.6616 16.2174 10.5262 16.1496C10.3907 16.0819 10.2601 15.9609 10.1344 15.7866L7.23216 12.2582C7.07739 12.0549 7 11.8468 7 11.6338C7 11.4112 7.07497 11.2224 7.22491 11.0676C7.37487 10.9127 7.5611 10.8352 7.78359 10.8352C7.91903 10.8352 8.04479 10.8643 8.16087 10.9223C8.27697 10.9804 8.39789 11.0869 8.52364 11.2418L10.947 14.3056L15.8953 6.45013C16.0791 6.15004 16.3064 6 16.5773 6C16.7901 6 16.9812 6.06776 17.1505 6.20329C17.3198 6.33881 17.4044 6.51789 17.4044 6.74052C17.4044 6.85669 17.3778 6.96802 17.3246 7.0745C17.2714 7.18098 17.2158 7.28262 17.1577 7.37943L11.8032 15.7866Z" fill="white"/>
          </svg>
          <span *ngIf="!isSavedCollectionCheck(sourceCollection)" class="web-btn-text" >Save</span>
          <span *ngIf="isSavedCollectionCheck(sourceCollection)"  class="web-btn-text" >Added</span>
        </button>

        <button *ngIf="!navForSavedCollection"  class="account-web-btn" [matMenuTriggerFor]="accountMenu">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="10.5" r="2" fill="white" />
            <circle cx="11" cy="10.5" r="2" fill="white" />
            <circle cx="19" cy="10.5" r="2" fill="white" />
          </svg>
          <span class="web-btn-text">More</span>
        </button>
        <mat-menu #accountMenu="matMenu">
          <app-webpanel [webpanelActionItems]="webNavService.editCollectionMoreWebPanelItems"
            (webpanelActionClickEvent)="handleWebpanelActionClick($event)"></app-webpanel>
        </mat-menu>

      </div>
      <div class="foot-last xs-alignSelfCenter gt-xs-alignSelfBase xs-removeMargin gt-xs-removeMargin gt-sm-fluidmargin1070">
        <app-library-section-switch *ngIf="!navForSavedCollection" #switchPanelRef [selectedSwitchBtn]="webNavService.currentWebSwitchPanelMode"  (switchBtnClicked)="webNavService.onWebNavSwitchPanelClick($event)"></app-library-section-switch>
      </div>
      </div>

    </ng-container>

    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.ACTIVE_EDIT_COLLECTION">

      <div class="foot-left-part"></div>
      <div class="foot-right-part">
      <div class="foot-main" >

        <button class="back-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)"  class="web-btn-text">Back</span>
        </button>

        <button class="add-web-btn main-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.SAVE, $event)">
          <span>Save</span>
        </button>


      </div>
      </div>

    </ng-container>


    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.ADD_FROM_LIBRARY">

      <div class="foot-left-part xs-flex0"></div>
      <div class="foot-right-part xs-columnreverse xs-flex100 gt-xs-columnreverse ">
      <div class="foot-main  xs-alignSelfCenter gt-xs-alignSelfBase gt-xs-mr20">

        <button class="back-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)"  class="web-btn-text">Back</span>
        </button>

        <button class="add-web-btn main-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.SAVE, $event)">
          <span>Save</span>
        </button>


      </div>
      <div class="foot-last xs-alignSelfCenter gt-xs-alignSelfBase xs-removeMargin gt-xs-removeMargin gt-sm-fluidmargin1070">
        <app-library-section-switch #switchPanelRef [selectedSwitchBtn]="webNavService.currentWebSwitchPanelMode"  (switchBtnClicked)="webNavService.onWebNavSwitchPanelClick($event)"></app-library-section-switch>
      </div>
      </div>

    </ng-container>

    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.PUBLISH_SELECTED_MODELS">
      <div class="foot-left-part xs-flex0"></div>
      <div class="foot-right-part xs-columnreverse xs-flex100 gt-xs-columnreverse">
      <div class="foot-main xs-alignSelfCenter gt-xs-alignSelfBase gt-xs-mr20">
        <button class="back-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)" class="web-btn-text">Back</span>
        </button>

        <button class="add-web-btn main-web-btn"
                [disabled]="userDataService.getIsNavbarMainActionDisabled()"
                (click)="navbarBtnClick(NAVBAR_BTN.PUBLISH, $event)">
          <span class="top-tag">Publish<span class="bottom-tag">Selected model</span> </span>
        </button>
      </div>
      </div>
    </ng-container>


    <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.SHARED_PAGE_ERROR">
      <div class="foot-left-part xs-flex0"></div>
      <div class="foot-right-part xs-columnreverse xs-flex100 gt-xs-columnreverse ">
      <div class="foot-main xs-alignSelfCenter gt-xs-alignSelfBase gt-xs-mr20" >
        <button class="home-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.HOME, $event)">
          <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 0.75L0.75 8.22675V21.25H7.0278V14.531C7.0278 14.0567 7.4083 13.6722 7.8778 13.6722H12.1222C12.5917 13.6722 12.9722 14.0567 12.9722 14.531V21.25H19.25V8.22674L10 0.75Z"
              fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.HOME, $event)">Home</span>
        </button>
        <button [disabled]="true" class="add-web-btn main-web-btn" (click)="handleUnauthorizedUserActionDetected()">
          <span>No action</span>
        </button>
        <button class="home-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
            <path d="M16.9167 4.2H5.08333M15.3333 1.5H6.66667M18 22.5H4C2.61929 22.5 1.5 21.3807 1.5 20L1.5 9.62673C1.5 8.24602 2.61929 7.12673 4 7.12673H18C19.3807 7.12673 20.5 8.24602 20.5 9.62673V20C20.5 21.3807 19.3807 22.5 18 22.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="web-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)">Library</span>
        </button>



        </div>
      </div>
    </ng-container>


    <!-- <ng-container #details *ngIf="webNavService.footerMode === FOOTER_MODE.PROFILE">
      <div class="profile-overlay" @fadeLeave (click)="navbarBtnClick(NAVBAR_BTN.BACK_PROFILE, $event)"></div>
      <div class="foot-left"><h2 class="web-title">Your Account</h2></div>
      <div class="foot-main">
        <button class="back-web-btn" (click)="navbarBtnClick(NAVBAR_BTN.BACK_PROFILE, $event)">
          <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span (click)="navbarBtnClick(NAVBAR_BTN.BACK_PROFILE, $event)"  class="web-btn-text">Back</span>
        </button>
        <a class="contact-us-btn" href="{{generateHref()}}"><span>Contact Us</span> </a>
        <button class="account-web-btn" [matMenuTriggerFor]="yourAccountMenu">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="10.5" r="2" fill="white" />
            <circle cx="11" cy="10.5" r="2" fill="white" />
            <circle cx="19" cy="10.5" r="2" fill="white" />
          </svg>
          <span class="web-btn-text">Account</span>
        </button>
        <mat-menu #yourAccountMenu="matMenu">
          <app-webpanel [webpanelActionItems]="getProperAccountItems()"
            (webpanelActionClickEvent)="handleWebpanelActionClick($event)">
          </app-webpanel>
        </mat-menu>
      </div>
      <div class="foot-right">
        <button class="close-acc-btn" (click)="onDeleteAccEventWeb()">
          <span> Close my account and delete my data</span>
        </button>
      </div>
    </ng-container> -->



  </div>

  <p *ngIf="webNavService.footerMode === FOOTER_MODE.LIBRARY && webNavService.shouldShowClassicLanding() && !shouldShowOpenAppCta()" class="navbar-refund-note">
    {{ webNavService.unauthLibraryRefundNote }}
  </p>

  <!-- Tablet/Mobile horizontal footer bar -->
  <!-- <div class="footer-row">

    <ng-container #details *ngIf="this.footerBarMode === FOOTER_MODE.LIBRARY">
      <button  class="home-btn-left"  (click)="navbarBtnClick(NAVBAR_BTN.HOME, $event)" >
        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 0.75L0.75 8.22675V21.25H7.0278V14.531C7.0278 14.0567 7.4083 13.6722 7.8778 13.6722H12.1222C12.5917 13.6722 12.9722 14.0567 12.9722 14.531V21.25H19.25V8.22674L10 0.75Z" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="home-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.HOME, $event)">Store</span>
      </button>

      <button *ngIf="!isUserAuthenticated" class="sign-in-with-apple" (click)="onSignInWithAppleClicked()">
        <svg (click)="onSignInWithAppleClicked()" class="apple-logo" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.0294 1.91442C13.5188 0.00928785 15.5895 0 15.5895 0C15.5895 0 15.8975 1.79114 14.4178 3.51659C12.8379 5.35898 11.0421 5.0575 11.0421 5.0575C11.0421 5.0575 10.7049 3.60853 12.0294 1.91442ZM11.2316 6.31219C11.9978 6.31219 13.4199 5.29003 15.2709 5.29003C18.4571 5.29003 19.7106 7.4903 19.7106 7.4903C19.7106 7.4903 17.2591 8.70672 17.2591 11.6583C17.2591 14.9879 20.313 16.1354 20.313 16.1354C20.313 16.1354 18.1782 21.9668 15.2946 21.9668C13.9702 21.9668 12.9406 21.1007 11.5451 21.1007C10.123 21.1007 8.71182 21.9991 7.79269 21.9991C5.15956 21.9992 1.83301 16.4675 1.83301 12.021C1.83301 7.64625 4.64872 5.35132 7.28974 5.35132C9.00665 5.35132 10.339 6.31219 11.2316 6.31219Z" fill="black"/>
        </svg>
        Continue with Apple
      </button>

      <ngx-file-drop *ngIf="isUserAuthenticated" [directory]="true"  class="upload-drop-zone" (onFileDrop)="dropped($event)"
               (click)="showBrowseBtn()">
              <ng-template  ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                      <button  class="browse-files" type="button" (click)="openFileSelector()">Upload</button>
              </ng-template>
      </ngx-file-drop>


      <button class="search-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
          <path d="M0.75 8.9375C0.75 13.4593 4.41567 17.125 8.9375 17.125C13.4593 17.125 17.125 13.4593 17.125 8.9375C17.125 4.41567 13.4593 0.75 8.9375 0.75C4.41567 0.75 0.75 4.41567 0.75 8.9375Z" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M20.9824 20.9687L15.3558 15.355" stroke="white" stroke-width="2" stroke-linecap="round"/>
          <circle xmlns="http://www.w3.org/2000/svg" cx="9" cy="9" r="5" />
        </svg>
        <span class="search-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">Search</span>
      </button>
    </ng-container>


    <ng-container #details *ngIf="this.footerBarMode === FOOTER_MODE.WEB_HOME">
      <button  class="library-btn-left empty-btn" >
      </button>

      <button *ngIf="!isUserAuthenticated" class="sign-in-with-apple" (click)="onSignInWithAppleClicked()">
        <svg (click)="onSignInWithAppleClicked()" class="apple-logo" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.0294 1.91442C13.5188 0.00928785 15.5895 0 15.5895 0C15.5895 0 15.8975 1.79114 14.4178 3.51659C12.8379 5.35898 11.0421 5.0575 11.0421 5.0575C11.0421 5.0575 10.7049 3.60853 12.0294 1.91442ZM11.2316 6.31219C11.9978 6.31219 13.4199 5.29003 15.2709 5.29003C18.4571 5.29003 19.7106 7.4903 19.7106 7.4903C19.7106 7.4903 17.2591 8.70672 17.2591 11.6583C17.2591 14.9879 20.313 16.1354 20.313 16.1354C20.313 16.1354 18.1782 21.9668 15.2946 21.9668C13.9702 21.9668 12.9406 21.1007 11.5451 21.1007C10.123 21.1007 8.71182 21.9991 7.79269 21.9991C5.15956 21.9992 1.83301 16.4675 1.83301 12.021C1.83301 7.64625 4.64872 5.35132 7.28974 5.35132C9.00665 5.35132 10.339 6.31219 11.2316 6.31219Z" fill="black"/>
        </svg>
        Continue with Apple
      </button>

      <button *ngIf="isUserAuthenticated" class="library-center-btn" (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)">
        Library
      </button>

      <button class="search-btn empty-btn" [disabled]="true" >

      </button>
    </ng-container>

    <ng-container #details *ngIf="this.footerBarMode === FOOTER_MODE.WEB_SANDBOX">
      <button  class="library-btn-left"  (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)" >
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
          <path d="M16.9167 4.2H5.08333M15.3333 1.5H6.66667M18 22.5H4C2.61929 22.5 1.5 21.3807 1.5 20L1.5 9.62673C1.5 8.24602 2.61929 7.12673 4 7.12673H18C19.3807 7.12673 20.5 8.24602 20.5 9.62673V20C20.5 21.3807 19.3807 22.5 18 22.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="library-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.LIBRARY, $event)">Library</span>
      </button>

      <button *ngIf="!isUserAuthenticated" class="sign-in-with-apple" (click)="onSignInWithAppleClicked()">
        <svg (click)="onSignInWithAppleClicked()" class="apple-logo" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.0294 1.91442C13.5188 0.00928785 15.5895 0 15.5895 0C15.5895 0 15.8975 1.79114 14.4178 3.51659C12.8379 5.35898 11.0421 5.0575 11.0421 5.0575C11.0421 5.0575 10.7049 3.60853 12.0294 1.91442ZM11.2316 6.31219C11.9978 6.31219 13.4199 5.29003 15.2709 5.29003C18.4571 5.29003 19.7106 7.4903 19.7106 7.4903C19.7106 7.4903 17.2591 8.70672 17.2591 11.6583C17.2591 14.9879 20.313 16.1354 20.313 16.1354C20.313 16.1354 18.1782 21.9668 15.2946 21.9668C13.9702 21.9668 12.9406 21.1007 11.5451 21.1007C10.123 21.1007 8.71182 21.9991 7.79269 21.9991C5.15956 21.9992 1.83301 16.4675 1.83301 12.021C1.83301 7.64625 4.64872 5.35132 7.28974 5.35132C9.00665 5.35132 10.339 6.31219 11.2316 6.31219Z" fill="black"/>
        </svg>
        Continue with Apple
      </button>

      <ngx-file-drop *ngIf="isUserAuthenticated" [directory]="true"  class="upload-drop-zone" (onFileDrop)="dropped($event)"
               (click)="showBrowseBtn()">
              <ng-template  ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                      <button  class="browse-files" type="button" (click)="openFileSelector()">Upload</button>
              </ng-template>
      </ngx-file-drop>


      <button class="search-btn" [disabled]="true" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">
          <path d="M0.75 8.9375C0.75 13.4593 4.41567 17.125 8.9375 17.125C13.4593 17.125 17.125 13.4593 17.125 8.9375C17.125 4.41567 13.4593 0.75 8.9375 0.75C4.41567 0.75 0.75 4.41567 0.75 8.9375Z" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M20.9824 20.9687L15.3558 15.355" stroke="white" stroke-width="2" stroke-linecap="round"/>
          <circle xmlns="http://www.w3.org/2000/svg" cx="9" cy="9" r="5" />
        </svg>
        <span class="search-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.SEARCH, $event)">Search</span>
      </button>
    </ng-container>

    <ng-container #details *ngIf="this.footerBarMode === FOOTER_MODE.SEARCH">
      <button class="back-btn" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)" >
        <svg (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)" width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span  class="back-btn-text" (click)="navbarBtnClick(NAVBAR_BTN.BACK, $event)">Back</span>
      </button>
      <button class="discover-btn" (click)="navbarBtnClick(NAVBAR_BTN.NOT_IMPL, $event)"><span  (click)="navbarBtnClick(NAVBAR_BTN.NOT_IMPL, $event)">Search</span></button>
      <button class="home-btn" ></button>
    </ng-container>

  </div> -->

  <div class="navbar-background-gradient"></div>
</div>
